import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormLabel from '@mui/material/FormLabel';
import Typography from '../../layouts/theme-onboarding/Typography';
import {
  validatePhone, validateEmail,
  validateIdentifyCitizenNumber, validateIdentifyNumber
} from '../../utils/regex/Regex';
import { initStep0Data } from '../../utils/object/Signup';
import PersonIcon from '@mui/icons-material/Person';
import Stack from '@mui/material/Stack';
import Color from '../../layouts/Color';

const info = { textAlign: 'left' };
const groupRadio = { alignSelf: 'flex-start' };
const container = { mt: 1 };
const iconColor = { color: Color.Main};

export default function Information(props) {

  const [phoneErrorText, setPhoneErrorText] = useState('');
  const [emailErrorText, setEmailErrorText] = useState('');
  const [idNumberErrorText, setIdNumberErrorText] = useState('');
  const [step0, setStep0] = useState(initStep0Data('', '', 'cmnd', ''));

  const handleChangePhone = (event) => {
    let value = event.target.value;
    let step0Data = handleValidatePhone(value);
    props.onUpdateStep0Data(step0Data);
  }

  const handleChangeEmail = (event) => {
    let value = event.target.value;
    let step0Data = handleValidateEmail(value);
    props.onUpdateStep0Data(step0Data);
  }

  const handleChangeIdNumber = (event) => {
    let value = event.target.value;
    let step0Data = handleValidateIdentifyNumber(value);
    props.onUpdateStep0Data(step0Data);
  }

  const handleChangeIdType = (event) => {
    let value = event.target.value;
    let step0Data = handleValidateIdentifyType(value);
    props.onUpdateStep0Data(step0Data);
  }

  function handleValidatePhone(phone) {
    let result = validatePhone(phone);
    let step0Data;
    if (!result) {
      step0Data = { ...step0, phone: phone, isPhoneError: true };
      setStep0(step0Data);
      setPhoneErrorText("Error Phone Format");
    } else {
      step0Data = { ...step0, phone: phone, isPhoneError: false };
      setStep0(step0Data);
      setPhoneErrorText("");
    }
    return step0Data;
  }

  function handleValidateEmail(email) {
    let result = validateEmail(email);
    let step0Data;
    if (!result) {
      step0Data = { ...step0, email: email, isEmailError: true };
      setStep0(step0Data);
      setEmailErrorText("Error Email Format");
    } else {
      step0Data = { ...step0, email: email, isEmailError: false };
      setStep0(step0Data);
      setEmailErrorText("");
    }
    return step0Data;
  }

  function handleValidateIdentifyType(type) {
    let result = (type === "cmnd") ? validateIdentifyNumber(step0.idNumber) : validateIdentifyCitizenNumber(step0.idNumber);
    let step0Data;
    if (!result) {
      step0Data = { ...step0, idType: type, isIdNumberError: true };
      setStep0(step0Data);
      setIdNumberErrorText("Error Identify Number Format");
    } else {
      step0Data = { ...step0, idType: type, isIdNumberError: false };
      setStep0(step0Data);
      setIdNumberErrorText("");
    }
    return step0Data;
  }

  function handleValidateIdentifyNumber(number) {
    let result = (step0.idType === "cmnd") ? validateIdentifyNumber(number) : validateIdentifyCitizenNumber(number);
    let step0Data;
    if (!result) {
      step0Data = { ...step0, idNumber: number, isIdNumberError: true };
      setStep0(step0Data);
      setIdNumberErrorText("Error Identify Number Format");
    } else {
      step0Data = { ...step0, idNumber: number, isIdNumberError: false };
      setStep0(step0Data);
      setIdNumberErrorText("");
    }
    return step0Data;
  }

  return (
    <React.Fragment>
      <Stack direction="row" justifyContent="center" spacing={1}>
        <Typography variant="h6" marked="left" gutterBottom color={Color.Main}>Information</Typography>
        <PersonIcon sx={iconColor}></PersonIcon>
      </Stack>
      <Grid container spacing={3} sx={container}>
        <Grid item xs={12} sx={info}> 
          <Typography variant="subtitle1" color={Color.Main}> Please provide basic information: </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="phone"
            name="phone"
            label="Phone"
            fullWidth
            autoComplete="phone"
            variant="standard"
            error={step0.isPhoneError}
            helperText={phoneErrorText}
            onChange={handleChangePhone}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="email"
            name="email"
            label="Email"
            fullWidth
            autoComplete="email"
            variant="standard"
            error={step0.isEmailError}
            helperText={emailErrorText}
            onChange={handleChangeEmail}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <FormLabel id="demo-row-radio-buttons-group-label" sx={groupRadio}>Identify Type: </FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              value={step0.idType}
              onChange={handleChangeIdType}
              name="radio-buttons-group"
            >
              <FormControlLabel value="cmnd" control={<Radio />} label="Identify Card" />
              <FormControlLabel value="cccd" control={<Radio />} label="Citizen Identify Card" />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="identify"
            name="identify"
            label="Identify Number"
            fullWidth
            autoComplete="idnumber"
            variant="standard"
            error={step0.isIdNumberError}
            helperText={idNumberErrorText}
            onChange={handleChangeIdNumber}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}